import { Service } from '@angular/core';

interface SavedDoorSetupFilter {
  projectId: string;
  model: Record<string, unknown> | null;
}

/**
 * Holds the latest door-setup grid filter model in memory so it survives any navigation away from the page.
 * The filter is scoped to the project it was saved for, so it never leaks into another project.
 */
@Service()
export class DoorSetupFilterService {
  private saved: SavedDoorSetupFilter | null = null;

  save(projectId: string, model: Record<string, unknown> | null): void {
    this.saved = { projectId, model };
  }

  restore(projectId: string): Record<string, unknown> | null {
    return this.saved?.projectId === projectId ? this.saved.model : null;
  }
}
